import { render, staticRenderFns } from "./EditBankHolder.vue?vue&type=template&id=71370584&scoped=true&"
import script from "./EditBankHolder.vue?vue&type=script&lang=js&"
export * from "./EditBankHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71370584",
  null
  
)

export default component.exports